<template>
  <AffiliateForm
    :affiliate="affiliate"
    :buttonLoading="buttonLoading"
    @saveAffiliate="saveAffiliate"
    @regenerateCode="generateAffiliateCode"
  />
</template>

<script>
import server from "../api";
import AffiliateForm from "@/components/AffiliateForm.vue";

export default {
  name: "AddAffiliate",
  components: {
    AffiliateForm,
  },
  data() {
    return {
      affiliate: {
        fullName: "",
        affiliateCode: "",
        contactNumber: "",
      },
      buttonLoading: false,
    };
  },
  methods: {
    generateAffiliateCode() {
      const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let code = "";

      for (let i = 0; i < 6; i += 1) {
        code += alphabet[Math.floor(Math.random() * alphabet.length)];
      }

      this.affiliate.affiliateCode = code;
    },
    saveAffiliate() {
      this.buttonLoading = true;
      server
        .post(
          "/affiliates",
          {
            full_name: this.affiliate.fullName,
            affiliate_code: this.affiliate.affiliateCode,
            contact_number: this.affiliate.contactNumber,
          },
          {
            headers: {
              token: localStorage.token,
            },
          }
        )
        .then((result) => {
          this.buttonLoading = false;
          const affiliate = result.data.Affiliate || result.data.data || this.affiliate;
          this.$store.commit(
            "SET_SUCCESS",
            `Success add affiliate ${affiliate.fullName || affiliate.full_name}`
          );
          this.$router.push({ name: "Affiliate" });
        })
        .catch((err) => {
          this.buttonLoading = false;
          const errorMessage =
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            (Array.isArray(err.response.data.errors)
              ? err.response.data.errors[0].message
              : err.response.data.errors.message);

          this.$store.commit("SET_ERROR", errorMessage || "Failed to add affiliate");
        });
    },
  },
  created() {
    this.generateAffiliateCode();
  },
};
</script>

<style></style>
